export default __webpack_public_path__ + "static/second-1b223a81cb8f2184b01d33a5c8f6d158.gif";